import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import * as _ from "lodash";

const Item = props => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    props.heightElement(height);
  }, [height])

  return (
    <div
      ref={element =>
        !_.isNull(element) ? setHeight(element.clientHeight) : null
      }
      className={
        props.active
          ? "container history-carousel__item history-carousel__item--active"
          : "container history-carousel__item"
      }
    >
      <div className="row">
        <div className="col-3 history-carousel__icon-area pb-4 pt-4">
          <button onClick={() => props.jumpTo(props.i)}>
            <div className="history-carousel__icon">
              <i
                className={
                  props.iconClass ? props.iconClass : "fas fa-calendar-week"
                }
              />
            </div>
          </button>
        </div>
        <div className="col-9 history-carousel__wrapper">
          <div className="history-carousel__header">
            <h2>
              <span>{props.year}</span>
              {props.title}
            </h2>
          </div>
          <div className="history-carousel__desc">
            <p>{props.desc}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
Item.propTypes = {
  active: PropTypes.bool
};

export default Item;
